// --- React
import React from 'react';
// --- UI Components
import { Col, Row } from 'antd';
import Typography from '@dtci/spellbook/Typography';
// --- Utils
import { getProspectDetails } from '../utils/getDetailsData';
// --- Styles
import '../../styles.scss';

/**
 * ProspectCard Component
 *
 * This component is responsible for rendering a card that displays detailed
 * information about a product's prospect data.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.details - The details of the product to be displayed.
 * @returns {JSX.Element} Prospect card with detailed information.
 **/
export function ProspectCard({ details }) {
    // Function to extract prospect details from the provided data
    const prospectDetails = getProspectDetails(details);

    return (
        <Row style={{ marginTop: 20 }}>
            <Col>
                {prospectDetails.map(({ label, value }, idx) => (
                    <Row key={`prospect-${idx}`}>
                        <Typography variant="T20">
                            <b>{label}:</b>
                            <br />
                            {value}
                        </Typography>
                    </Row>
                ))}
            </Col>
        </Row>
    );
}
